import React, { useContext } from 'react';
import { GroupTestimonialModule } from './GroupTestimonialModule';
import { HeroBodyCarousel, HeroBodyModule } from './HeroBody';
import { HeroNarrativeCarouselModule, HeroNarrativeCoverModule, HeroNarrativeQuoteModule, HeroNarrativeTextModule, } from './HeroNarrative';
import { MiniCarouselNarrativeModule } from './MiniCarouselNarrativeModule';
import { SingleTestimonialModule } from './SingleTestimonialModule';
import { VideoModule } from './VideoModule';
import { AnimationContext, customThreshold, useAnimations } from '../ui';
import { mergeRefs } from '../ui/utils';
import { AccordionModule } from './AccordionModule';
import { JumpLinkHeroModule } from './JumpLinkHero';
import { ChecklistModule } from './ChecklistModule';
import { LinkGridModule } from './LinkGridModule';
import { GraphicTransitionModule } from './GraphicTransitionModule';
import { GraphicTransitionContext } from '../Context/GraphicTransitionContext';
import { FullWidthVideoModule } from './FullWidthVideoModule';
import { TwoUpModule } from './TwoUpFeaturedContentModule';
import { FullWidthCarouselModule } from './FullWidthCarouselModule';
import { PageBreakerModule } from './PageBreakerModule';
import { HeaderModule } from './HeaderModule';
import { DataHighlightModule } from './DataHighlightModule';
export const MODULE_COMPONENTS = {
    accordionModule: AccordionModule,
    dataHighlightModule: DataHighlightModule,
    checklistModule: ChecklistModule,
    linkGridModule: LinkGridModule,
    groupTestimonial: GroupTestimonialModule,
    graphicTransitionModule: GraphicTransitionModule,
    heroBodyCarousel: HeroBodyCarousel,
    heroBodyModule: HeroBodyModule,
    jumpLinkHeroModule: JumpLinkHeroModule,
    heroNarrativeCarousel: HeroNarrativeCarouselModule,
    heroNarrativeCover: HeroNarrativeCoverModule,
    heroNarrativeQuoteSlide: HeroNarrativeQuoteModule,
    headerModule: HeaderModule,
    heroNarrativeTextSlide: HeroNarrativeTextModule,
    miniCarouselNarrative: MiniCarouselNarrativeModule,
    singleTestimonial: SingleTestimonialModule,
    videoModule: VideoModule,
    fullWidthVideoModule: FullWidthVideoModule,
    fullWidthCarouselModule: FullWidthCarouselModule,
    featuredContent2Up: TwoUpModule,
    pageBreakerModule: PageBreakerModule,
};
export const Module = React.forwardRef((props, ref) => {
    const { contentType, shouldAnimate = true, className = '', onShowSlide, modulePageIndex, } = props;
    const ModuleComponent = MODULE_COMPONENTS[contentType];
    const { animationContext, animationRef } = useAnimations(contentType, shouldAnimate, customThreshold(contentType));
    const { getTransitionColors, showCarouselSlide } = useContext(GraphicTransitionContext);
    const showSlideWithContext = (slide, idx) => {
        if (showCarouselSlide)
            showCarouselSlide(props, slide);
        if (onShowSlide)
            onShowSlide(slide, idx);
    };
    const isTransitionModule = contentType === 'graphicTransitionModule';
    const modProps = {
        ...props,
        onShowSlide: showSlideWithContext,
        transitionColors: isTransitionModule &&
            modulePageIndex &&
            getTransitionColors &&
            getTransitionColors(modulePageIndex),
    };
    if (ModuleComponent) {
        return (React.createElement(AnimationContext.Provider, { value: animationContext },
            React.createElement(ModuleComponent, { ...modProps, ref: mergeRefs(ref, animationRef), className: className })));
    }
    return React.createElement(React.Fragment, null,
        "Module type \"",
        contentType,
        "\" not found");
});
export { AccordionModule, DataHighlightModule, JumpLinkHeroModule, ChecklistModule, GroupTestimonialModule, GraphicTransitionModule, HeaderModule, HeroBodyCarousel, HeroBodyModule, HeroNarrativeCarouselModule, HeroNarrativeCoverModule, HeroNarrativeQuoteModule, HeroNarrativeTextModule, LinkGridModule, MiniCarouselNarrativeModule, SingleTestimonialModule, VideoModule, FullWidthVideoModule, FullWidthCarouselModule, TwoUpModule, PageBreakerModule, };
